// hooks/useAPI.js
import { useState, useEffect, useCallback, useRef } from 'react';
import apiClient from '../services/apiClient';

export const useAPI = (url, options = {}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Utiliser des références pour stabiliser les dépendances
    const prevUrlRef = useRef();
    const prevOptionsRef = useRef();

    const fetchData = useCallback(async () => {
        if (!url) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);
        
        try {
            const response = await apiClient({ url, ...options });
            setData(response.data);
        } catch (err) {
            console.error(`useAPI Error: Failed to fetch ${url}`, err);
            setError(err.response?.data?.detail || 'Une erreur est survenue lors de la récupération des données.');
        } finally {
            setLoading(false);
        }
    }, [url]); // Dépendance à l'URL qui est stable

    useEffect(() => {
        // Ne refaire l'appel que si l'URL a réellement changé
        if (url !== prevUrlRef.current) {
            fetchData();
            prevUrlRef.current = url;
            prevOptionsRef.current = options;
        }
    }, [url, fetchData]);

    // Fonction de rappel pour forcer un nouvel appel
    const refetch = useCallback(() => {
        fetchData();
    }, [fetchData]);

    return { data, loading, error, refetch };
};
